module.exports = __webpack_public_path__ + "static/media/create-min-min.8c52eacd.png";